'use client'
import React, {ReactNode, useMemo} from 'react'
import classnames from 'classnames'
import {LinkProps} from 'next/link'

import {useParams} from '../../../hooks/useParams'
import {tg} from '../../../ui/styleGenerators/typography'
import {TTypographyProps} from '../../../ui/styleGenerators/typography/types'
import {addParamsToUrl} from '../../../utils/addParamsToUrl'
import {GoalLink} from './GoalLink'

import styles from './styles.module.css'

export type TLink = {
  children?: ReactNode
  className?: string
  goal?: string
  variant?: 'light' | 'dark'
  underline?: boolean
} & Pick<TTypographyProps, 'kind'> &
  LinkProps

export function Link({
  children,
  className,
  href,
  goal,
  variant = 'dark',
  underline = true,
  kind = 'body',
  ...props
}: TLink) {
  const {params} = useParams()
  const stringHref = useMemo(() => addParamsToUrl(href?.toString() || '', params), [params, href])

  const linkProps = {
    className: classnames(
      tg({kind}),
      styles.root,
      styles[variant],
      {[styles.underline]: Boolean(underline)},
      className,
    ),
    ...props,
  }

  return (
    <>
      {href?.toString().includes('$modal:') || goal ? (
        <GoalLink goal={goal} href={stringHref} {...linkProps}>
          {children}
        </GoalLink>
      ) : (
        <a {...linkProps} href={stringHref}>
          {children}
        </a>
      )}
    </>
  )
}
